import * as React from 'react';
import { PageProps } from 'gatsby';
import Layout from '../components/Layout';
import { EquationContainer } from '../components/Equations/EquationContainer';
import { TankCircuitComponent } from '../components/Equations/TankCircuitComponent';

export default function TankCircuitPage(props: PageProps): JSX.Element {
  const pageTitle = 'Tank Circuit';

  return (
    <Layout location={props.location} title={pageTitle}>
      <EquationContainer>
        <TankCircuitComponent />
      </EquationContainer>
    </Layout>
  );
}
